import React from "react";
import classNames from "classnames";
import PropTypes from "prop-types";
import { useField } from "formik";
import FormControl from "@material-ui/core/FormControl";
import InputLabel from "@material-ui/core/InputLabel";
import Input from "@material-ui/core/Input";
import { useStyles } from "styles/StyleDashboard";

const CustomInputForm = ({value, labelText, ...props }) => {
  const classes = useStyles();
  const { formcontrolprops, id, labelProps, error, success } = props;
  const [field, meta] = useField(props);
  const labelClasses = classNames({
    [" " + classes.labelRootError]: error || (meta.touched && meta.error),
    [" " + classes.labelRootSuccess]:
      success && !error && !(meta.touched && meta.error)
  });
  const underlineClasses = classNames({
    [classes.underlineError]: error || (meta.touched && meta.error),
    [classes.underlineSuccess]:
      success && !error && !(meta.touched && meta.error),
    [classes.underline]: true
  });
  const marginTop = classNames({
    [classes.marginTop]: labelText === undefined
  });

  return (
    <>
      <FormControl
        {...formcontrolprops}
        className={
          formcontrolprops &&
          formcontrolprops.className + " " + classes.formControl
        }
      >
        {labelText !== undefined ? (
          <InputLabel
            className={classes.labelRoot + labelClasses}
            htmlFor={id}
            {...labelProps}
          >
            {labelText}
          </InputLabel>
        ) : null}
        <Input
          classes={{
            root: marginTop,
            disabled: classes.disabled,
            underline: underlineClasses
          }}
          {...field}
          {...props}
          value={value}
        />
        {meta.touched && meta.error ? (
          <div className={classes.error}>{meta.error}</div>
        ) : null}
      </FormControl>
    </>
  );
};

CustomInputForm.propTypes = {
  labelText: PropTypes.string,
  props: PropTypes.any,
  formcontrolprops: PropTypes.any,
  labelProps: PropTypes.any,
  inputProps: PropTypes.any,
  id: PropTypes.string,
  error: PropTypes.any,
  success: PropTypes.string,
  value: PropTypes.any
};
export default CustomInputForm;
